// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMFilterBuilderComponent } from '@modal/filter-builder/lm-filter-builder.component';
import { Observable, Subject } from 'rxjs';
import { SohoMessageService, SohoModalDialogService } from 'ids-enterprise-ng';
import { FilterBuilderDialogResult } from '@utils/index';
import { LMFormatUtilService } from '@services/utils';

@Injectable()
export class LMFilterBuilderService {
  constructor(private sohoModalDialogService: SohoModalDialogService,
    private lmFormatUtilService: LMFormatUtilService,
    private sohoMessageService: SohoMessageService) {
  }

  public openBuilderDialog(busclass: string, fieldLookUpUrl: string, fieldSearchUrl: string,  lplValidationUrl: string, hasExistingCondition: boolean, includeAuditFields?: boolean): Observable<LMFilterBuilderResult> {
    let lmFilterBuilderComponentRef: LMFilterBuilderComponent;
    const returnQuery = new Subject<LMFilterBuilderResult>();

    const closeModalWith = (result, modal) => {
      if (result === FilterBuilderDialogResult.CONFIRMATION_CANCEL) {
        modal.close(true);
        returnQuery.next({ dialogResult: result, lplQuery: undefined, matchOption: lmFilterBuilderComponentRef.matchOption });
        returnQuery.complete();
        return;
      }

      lmFilterBuilderComponentRef.validateFilterConditions().subscribe(valid => {

        if (valid) {
          const lplQuery = this.convertFilterRowCriteria(lmFilterBuilderComponentRef.filterRows, lmFilterBuilderComponentRef.matchOption);
          modal.close(true);
          returnQuery.next({ dialogResult: result, lplQuery, matchOption: lmFilterBuilderComponentRef.matchOption });
          returnQuery.complete();
        }
      });
    };

    // Create modal button
    const buttons = [
      {
        text: Soho.Locale.translate('Cancel'),
        click: (e, modal) => {
          closeModalWith(FilterBuilderDialogResult.CONFIRMATION_CANCEL, modal);
        },
        isDefault: false
      }
    ];

    if (hasExistingCondition) {
      buttons.push(
        {
          text: Soho.Locale.translate('Append'),
          click: (e, modal) => {
            closeModalWith(FilterBuilderDialogResult.CONFIRMATION_APPEND, modal);
          },
          isDefault: true
        },
        {
          text: Soho.Locale.translate('Overwrite'),
          click: (e, modal) => {
            closeModalWith(FilterBuilderDialogResult.CONFIRMATION_OVERWRITE, modal);
          },
          isDefault: false
        }
      );
    } else {
      buttons.push(
        {
          text: Soho.Locale.translate('Ok'),
          click: (e, modal) => {
            closeModalWith(FilterBuilderDialogResult.CONFIRMATION_OK, modal);
          },
          isDefault: true
        }
      );
    }

    const attributes: SohoAttributesArray = [{ name: 'data-automation-id', value: 'lm-filter-builder-modal' }];

    this.sohoModalDialogService
      .modal(LMFilterBuilderComponent, null, <SohoModalOptions>{ attributes })
      .options({ fullsize: 'responsive' })
      .cssClass('lm-filter-builder')
      .title(this.lmFormatUtilService.formatMessage(Soho.Locale.translate('LplConditionBuilderTitle'), busclass))
      .buttons(buttons)
      .open()
      .apply((dialogComponent: LMFilterBuilderComponent) => {
        lmFilterBuilderComponentRef = dialogComponent;
        lmFilterBuilderComponentRef.businessClass = busclass;
        lmFilterBuilderComponentRef.lookupUrl = fieldLookUpUrl;
        lmFilterBuilderComponentRef.fieldSearchUrl = fieldSearchUrl;
        lmFilterBuilderComponentRef.lplValidationUrl = lplValidationUrl;
        lmFilterBuilderComponentRef.includeAuditFields = includeAuditFields;
      });

    return returnQuery.asObservable();
  }

  public convertFilterRowCriteria(filterRows: Array<FilterRow>, macthOption: string): string {
    const sb: Array<string> = [];

    filterRows.forEach(filterRow => {
      let rowCondition = '';
      if (filterRow.condition === 'false') {
        rowCondition += '!';
      }

      rowCondition += filterRow.subject.text;

      if (filterRow.condition !== 'false') {
        rowCondition += ' ';
      }

      switch (filterRow.condition) {
        case 'equalTo':
          rowCondition += '= ';
          break;
        case 'notEqualTo':
          rowCondition += '!= ';
          break;
        case 'entered':
          rowCondition += 'entered';
          break;
        case 'notEntered':
          rowCondition += 'not entered';
          break;
        case 'greaterThan':
          rowCondition += '>';
          break;
        case 'greaterThanOrEqualTo':
          rowCondition += '>=';
          break;
        case 'lessThan':
          rowCondition += '<';
          break;
        case 'lessThanOrEqualTo':
          rowCondition += '<=';
          break;
        case 'exist':
          rowCondition += 'exists';
          break;
        case 'doesNotExist':
          rowCondition += 'not exists';
          break;
        case 'like':
          rowCondition += 'like';
          break;
      }

      if (filterRow.predicate.text.trim().length !== 0) {
        if (filterRow.literal && filterRow.subject.type !== 'NUMBER') {
          rowCondition += ` "${filterRow.predicate.text}"`;
        } else {
          rowCondition += ` ${filterRow.predicate.text}`;
        }
      }

      if (rowCondition.trim().length > 0) {
        sb.push('(' + rowCondition + ')');
      }
    });

    let instanceSelection = '';
    if (sb.length > 0 ) {
      sb.forEach((s, i) => {
        instanceSelection += `${s}`;
        if (sb.length > 1 && (i + 1) !== sb.length ) {
          instanceSelection += ` ${macthOption} `;
        }
      });
      return instanceSelection;
    } else {
      return instanceSelection;
    }
 }

}
